import { CheckNotes, InspectionCase } from '../../inspection-cases';

export class PumpRoomInstallationMainDto extends InspectionCase {
  certificateNumber?: InspectionCase;
  reportReceived?: InspectionCase;
}

export class PumpRoomInstallationMain extends PumpRoomInstallationMainDto {
  constructor(
    data: PumpRoomInstallationMainDto = { title: 'חדר משאבות - כללי' }
  ) {
    super(data);
    this.certificateNumber = new InspectionCase({
      ...data.certificateNumber,
      title: 'במידה וקיים אישור לתכנון, ציין את מספר התעודה'
    });
    this.reportReceived = new InspectionCase({
      ...data.reportReceived,
      title: `התקבל דו"ח הפעלה של חדר המשאבות שבוצע ע"י ספק המשאבה/ות`
    });
  }

  setInspectionStatus(): void {
    this.isPassed =
      !this.isApplicable ||
      ((!this.certificateNumber.isApplicable ||
        this.certificateNumber.isPassed) &&
        (!this.reportReceived.isApplicable || this.reportReceived.isPassed));
  }

  getNotes?(): CheckNotes[] {
    if (!this.isApplicable) {
      return [];
    }
    return [
      ...this.certificateNumber.getNotes(),
      ...this.reportReceived.getNotes()
    ];
  }
}
